// Rendered by the root route while beforeLoad runs.
// Mirrors index.html so the header never disappears.
export default function AppShellPending() {
  return (
    <div className="app-shell" aria-busy="true">
      <div className="app-shell-header">
        <div className="app-shell-mark"><span>A</span></div>
        <span className="app-shell-title">ALFIE AI</span>
      </div>
      <div className="app-shell-body">
        <div className="app-shell-pulse"></div>
      </div>
    </div>
  );
}
